import { connect } from 'react-redux'

import { BIOME_RESULTS } from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'

import Component from './BiomeResults'

function mapStateToProps() {
  return {}
}

const LocalizedComponent = withLocalization(Component, BIOME_RESULTS)

export default connect(mapStateToProps, null)(LocalizedComponent)
